<div class="page-loader" [ngClass]="{ 'page-loader--done': done() }" [ngStyle]="{ 'width.%': width() }"></div>
